import React, { Component } from 'react';
import Loader from 'react-loader';
import firebase from "./Firebase"


class VerifyEmail extends Component {
  constructor(props) {
    super(props)

    this.state = {
      error: '',
      validCode: null,
      verifiedCode: false,
    }
  }

  componentDidMount() {
    firebase.auth()
      .applyActionCode(this.props.actionCode)
      .then(() => {
        this.setState({ validCode: true, verifiedCode: true });
      }, error => {
        this.setState({ error: error.message, validCode: false, verifiedCode: true });
      });
  }

  continueHandler = () => {
    this.props.history.push("/")
  }

  render() {
    const {
      error,
      validCode,
      verifiedCode,
    } = this.state;

    let component;
    if (!verifiedCode) {
      component = (<div className="text-xs-center spinnerHome">
        <Loader className="loader" color='#6f2c91' scale={1.5} loaded={false} />
      </div>);

    } else if (verifiedCode && validCode) {
      component = (
        <div className="login-register-page container page">
          <div className="row form-container">
            <div className="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-6  col-xs-8 form-center form-box" >
              <h6 className="text-center">Your email has been verified successfully.</h6>
              <button className="btn btn-primary btn-block break-line" onClick={this.continueHandler}>Continue Exploring SONIA Realised Rates</button>
            </div> </div> </div>
      );
    } else if (verifiedCode && !validCode) {
      component = (
        <div className="login-register-page container page">
          <div className="row form-container">
            <div className="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-6  col-xs-8 form-center form-box" >
              <h6 className="text-center">Try verifying your email again.</h6>
              <p className="error">{error}</p>
              <button className="btn btn-primary btn-block break-line" onClick={this.continueHandler}>Continue exploring SONIA Realised Rates</button>
            </div>
          </div>
        </div>
      );
    }
    return component;
  }
}

export default VerifyEmail;


// WEBPACK FOOTER //
// ./src/components/VerifyEmail.js